/**
 * `ez.t.cron_oneoff` — the `oneOff` recipe (`3000`, 18 automations). Its config is a shape of its
 * own: `listeners[0].config` is a five-field cron in UTC. The scheduler materialises exactly one
 * `one_off` row from it and, after firing, `state` becomes `one_off` so it never fires again —
 * which is why three production rows are `active:true / state:one_off` (`specs/M6-A1` §5.6).
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
import { AUTOMATION_SCHEDULE_DUE } from '../events.js';
export const cronOneOffParams = z.object({
    listeners: z
        .array(z.object({ provider: z.string().optional(), type: z.string().optional(), config: z.string() }))
        .default([]),
    resourceMetadata: z.record(z.string(), z.unknown()).optional(),
});
export const cronOneOffTrigger = defineTrigger({
    id: 'ez.t.cron_oneoff',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'One Off Automation',
    paramsSchema: cronOneOffParams,
    subscribes: [AUTOMATION_SCHEDULE_DUE],
    timeBased: true,
    assumed: true,
    references: () => [],
    matches: () => true,
    outputs(event) {
        return { boardId: event.boardId, itemId: event.itemId, dueAt: event.payload.dueAt };
    },
});
//# sourceMappingURL=ez.t.cron-oneoff.js.map